const SanMarinoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112253)">
      <path
        d="M40 20.0003C40 31.0459 31.0456 40.0003 20 40.0003C8.95437 40.0003 0 31.0459 0 20.0003C0.869531 20.0003 20 17.3916 20 17.3916L40 20.0003Z"
        fill="#338AF3"
      />
      <path d="M0 20C0 8.95437 8.95437 0 20 0C31.0456 0 40 8.95437 40 20" fill="#F0F0F0" />
      <path
        d="M27.939 13.7998L20.0002 21.7386L12.0615 13.7998C11.0348 15.3238 10.4351 17.1581 10.4351 19.1299V21.7386C10.4351 25.9273 13.1417 29.4955 16.8977 30.787C16.3964 31.7695 16.4809 32.9957 17.2155 33.9125C18.1912 33.1305 19.2012 32.3211 20.0581 31.6345C20.915 32.3211 21.9251 33.1306 22.9007 33.9125C23.6439 32.985 23.7223 31.7404 23.2012 30.7521C26.9059 29.4326 29.5654 25.8906 29.5654 21.7386V19.13C29.5654 17.1581 28.9656 15.3239 27.939 13.7998Z"
        fill="#6DA544"
      />
      <path
        d="M19.9999 28.6945C16.1641 28.6945 13.0435 25.5738 13.0435 21.738V19.1293C13.0435 15.2935 16.1642 12.1729 19.9999 12.1729C23.8357 12.1729 26.9564 15.2936 26.9564 19.1293V21.738C26.9564 25.5738 23.8358 28.6945 19.9999 28.6945Z"
        fill="#FFDA44"
      />
      <path
        d="M24.348 21.7397V19.131C24.348 16.7336 22.3975 14.7832 20.0002 14.7832C17.6028 14.7832 15.6523 16.7337 15.6523 19.131V21.7397L20.0002 22.6092L24.348 21.7397Z"
        fill="#338AF3"
      />
      <path
        d="M15.6523 21.7402C15.6523 24.1377 17.6028 26.088 20.0002 26.088C22.3975 26.088 24.348 24.1376 24.348 21.7402H15.6523Z"
        fill="#6DA544"
      />
      <path
        d="M25.2175 12.1739C25.2175 10.7332 24.0495 9.56519 22.6088 9.56519C21.9404 9.56519 21.3313 9.81676 20.8697 10.23V8.69559H21.7392V6.95645H20.8697V6.08691H19.1305V6.95645H18.261V8.69559H19.1305V10.23C18.6689 9.81676 18.0597 9.56519 17.3914 9.56519C15.9507 9.56519 14.7827 10.7332 14.7827 12.1739C14.7827 12.9463 15.1187 13.64 15.6522 14.1178V15.6521H24.3479V14.1178C24.8815 13.64 25.2175 12.9463 25.2175 12.1739Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112253">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SanMarinoSvg;
